'use client';
import type { JSX } from 'react';

import {
  DatePickerInput as MantineDatePickerInput,
  type DatePickerInputProps,
  type DatePickerType,
} from '@mantine/dates';

type DatePickerInputComponent = (<Type extends DatePickerType = 'default'>(
  props: DatePickerInputProps<Type> & {
    displayName?: string;
    placeholder: string;
  },
) => JSX.Element) & {
  displayName?: string;
  placeholder?: string;
};

export const DatePickerInput: DatePickerInputComponent = ({ type = 'default', allowDeselect = true, ...props }) => (
  <MantineDatePickerInput
    type={type}
    //@ts-expect-error need to fix this
    allowDeselect={type === 'default' ? allowDeselect : undefined}
    clearable
    weekendDays={[]}
    {...props}
  />
);

DatePickerInput.displayName = 'DatePickerInput';
